export default (data) => Boolean(data.EdgeId && data.From && data.To);
